import { Button, Dialog } from "@material-ui/core";
import styles from "./Announcement.module.scss";
import Clear from "@material-ui/icons/Clear";
import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import AnnouncementClient from "../../../shared/clients/AnnouncementClient";
import { withTranslation } from "react-i18next";

const StyledDialog = withStyles({
  paper: {
    width: 600,
    maxWidth: 600,
  },
})(Dialog);

class AnnouncementDialogEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      announcementText: this.props.description,
    };
  }

  handleClose = () => {
    this.props.closeModal();
    this.setState({ announcementText: this.props.description });
  };

  handleChange = (event) => {
    this.setState({ announcementText: event.target.value });
  };

  handleUpdate = () => {
    const announcementObj = {
      market: this.props.selectedMarket,
      updatedBy: this.props.user.userId,
      announcement: this.state.announcementText,
      active: true,
    };

    AnnouncementClient.updateAnnouncement(
      this.props.user,
      announcementObj,
      this.props.id
    )
      .then(() => {
        this.props.closeModal();
        this.props.getAnnouncements();
      })
      .catch(() => {});
  };

  render() {
    return (
      <StyledDialog open={this.props.open}>
        <div className={styles.wrapper}>
          <button className={styles.close} onClick={this.handleClose}>
            <Clear />
          </button>
          <div className={styles.header}>
            {this.props.t("Announcement.editDialogTitle")}
          </div>
          <div className={styles.textAreaTitle}>
            {this.props.t("Announcement.announcementTitle")}
          </div>
          <div className={styles.textAreaContainer}>
            <textarea
              value={this.state.announcementText}
              onChange={this.handleChange}
              maxLength={this.props.maxlength}
            />
          </div>

          <div className={styles.charsRemainingText}>
            {this.props.t("Announcement.charactersRemaining")}
            {this.props.maxlength - this.state.announcementText.length}
          </div>
          <div className={styles.buttonRowContainer}>
            <Button
              className={styles.cancelledDialogButton}
              onClick={this.handleClose}
            >
              {this.props.t("Announcement.cancelBtn")}
            </Button>
            <Button className={styles.actionBtn} onClick={this.handleUpdate}>
              {this.props.t("Announcement.publishBtn")}
            </Button>
          </div>
        </div>
      </StyledDialog>
    );
  }
}

export default withTranslation("emp")(AnnouncementDialogEdit);
